
namespace appn {
    
    export enum IDTSortDir {
        asc = 'asc',
        desc = 'desc'
    }

    export enum IDTColumnType {
        string = 'string',
        numeric = 'numeric',
        date = 'date',
        html = 'html'
    }

    export interface IDTDataResult {
        iTotalResults: number;
        iTotalDisplayRecords: number;
        sColumns: string;
        aaData: Array<Array<string>>;
    }

    export interface IDTColumns {
        // https://legacy.datatables.net/usage/columns [READ THIS FOR MORE INFO ON ANY OF THE PROPERTIES]
        aDataSort: Array<number>;
        asSorting: Array<IDTSortDir>;
        bSearchable: boolean;
        bSortable: boolean;
        bVisible: boolean;
        fnCreatedCell: Function;
        iDataSort: number;
        mData: number | string | undefined | Function;
        mRender: number | string | Function;
        sCellType: string;
        sClass: string;
        sContentPadding: string;
        sDefaultContent: string;
        sName: string;
        sSortDataType: string;
        sTitle: string;
        sType: IDTColumnType;
        sWidth: string;
    }

    export interface IDTColumnDefs extends IDTColumns {
        aTargets: Array<string | number>;
    }

    export interface IActionButtons {
        [key: string]: IActionButton;
        Back: IActionButton;
        StartBilling: IActionButton;
        UpdateBilling: IActionButton;
        ChangeCard: IActionButton;
        ChargeCard: IActionButton;
        CancelBilling: IActionButton;
        ProcessPayment: IActionButton;
        CancelAddCreditCard: IActionButton;
        ProceedAddCreditCard: IActionButton;
        Activate: IActionButton;
        AddConnector: IActionButton;
        AddFilter: IActionButton;
        Add: IActionButton;
        AddNew: IActionButton;
        Archive: IActionButton;
        Apply: IActionButton;
        Authorize: IActionButton;
        Close: IActionButton;
        Cancel: IActionButton;
        Create: IActionButton;
        Deactivate: IActionButton;
        Delete: IActionButton;
        DeleteAll: IActionButton;
        Disconnect: IActionButton;
        DownloadFile: IActionButton;
        Edit: IActionButton;
        Export: IActionButton;
        FilterOptions: IActionButton;
        Go: IActionButton;
        Import: IActionButton;
        Install: IActionButton;
        Invoice: IActionButton;
        Lock: IActionButton;
        Manage: IActionButton;
        ManageInstalls: IActionButton;
        ManageTesting: IActionButton;
        NewVersion: IActionButton;
        Organise: IActionButton;
        Publish: IActionButton;
        Print: IActionButton;
        Reactivate: IActionButton;
        Remove: IActionButton;
        ResetPassword: IActionButton;
        Retire: IActionButton;
        Revoke: IActionButton;
        Save: IActionButton;
        Search: IActionButton;
        Send: IActionButton;
        SendInvite: IActionButton;
        SignIn: IActionButton;
        StartTesting: IActionButton;
        StopTesting: IActionButton;
        SubmitForReview: IActionButton;
        TestScreen: IActionButton;
        Unlock: IActionButton;
        Checklist: IActionButton;
        Package: IActionButton;
        UpdateTesting: IActionButton;
        CreateConnector: IActionButton;
    }

    export enum ButtonAction {
        // Billing actions
        StartBilling = 'StartBilling',
        UpdateBilling = 'UpdateBilling',
        ChangeCard = 'ChangeCard',
        ChargeCard = 'ChargeCard',
        CancelBilling = 'CancelBilling',
        ProcessPayment = 'ProcessPayment',
        PayNow = 'PayNow',
        CancelAddCreditCard = 'CancelAddCreditCard',
        ProceedAddCreditCard = 'ProceedAddCreditCard',
        // General Actions
        Activate = 'Activate',
        AddConnector = 'AddConnector',
        AddFilter = 'AddFilter',
        Add = 'Add',
        AddNew = 'AddNew',
        Archive = 'Archive',
        Apply = 'Apply',
        Authorize = 'Authorize',
        Cancel = 'Cancel',
        Close = 'Close',
        Create = 'Create',
        Deactivate = 'Deactivate',
        Delete = 'Delete',
        DeleteAll = 'DeleteAll',
        Disconnect = 'Disconnect',
        DownloadFile = 'DownloadFile',
        Edit = 'Edit',
        Export = 'Export',
        FilterOptions = 'FilterOptions',
        Go = 'Go',
        Import = 'Import',
        ImportUsers = 'ImportUsers',
        Install = 'Install',
        Invoice = 'Invoice',
        Lock = 'Lock',
        Manage = 'Manage',
        ManageInstalls = 'ManageInstalls',
        ManageTesting = 'ManageTesting',
        Move = 'Move',
        NewVersion = 'NewVersion',
        Organise = 'Organise',
        Print = 'Print',
        Publish = 'Publish',
        Reactivate = 'Reactivate',
        Remove = 'Remove',
        ResetPassword = 'ResetPassword',
        Retire = 'Retire',
        Revoke = 'Revoke',
        Save = 'Save',
        Search = 'Search',
        Send = 'Send',
        SendInvite = 'SendInvite',
        SignIn = 'SignIn',
        StartTesting = 'StartTesting',
        StopTesting = 'StopTesting',
        SubmitForReview = 'SubmitForReview',
        TestScreen = 'TestScreen',
        Unlock = 'Unlock',
        UpdateTesting = 'UpdateTesting',
        Checklist = 'Checklist',
        Back = 'Back',
        Package = 'Package',
        CreateConnector = 'CreateConnector',
        WebFormUrl = 'WebFormUrl',
    }

    export interface IActionButton {
        ButtonColourClass: string;
        IconClass: string;
        Text: string;
    }

    export interface IActionButtonConfig {
        buttonId: string;
        buttonType: string;
        isDisabled?: boolean;
        buttonText?: string;
        isDataTableToggleBtn?: boolean;
    }

    export interface IdtFilterValues {
        type: string;
        fromDate: string;
        toDate: string;
    }
    
    export interface PagingToolbar {
        init: Function;
        pageSize: number;
        pageNum: number;
        totalUsers: number;
        updateUi: Function;
    }
}
